import { parsePaymentUri } from "./paymentUri/parsePaymentUri"

export function parseScannedRecipient(rawValue: string): string {
  const trimmed = rawValue.trim()
  if (!trimmed) return ""

  const parsed = parsePaymentUri(trimmed)
  if (parsed.kind === "accepted") {
    return parsed.payment.recipient
  }

  if (trimmed.startsWith("near:")) {
    const nearRecipient = trimmed.slice("near:".length).split("?")[0]
    return nearRecipient.trim()
  }

  try {
    const parsedUrl = new URL(trimmed)
    const recipientParam =
      parsedUrl.searchParams.get("recipient") ??
      parsedUrl.searchParams.get("address") ??
      parsedUrl.searchParams.get("account")

    if (recipientParam) {
      return recipientParam.trim()
    }
  } catch {
    return trimmed
  }

  return trimmed
}
